import { getAPI, postAPI } from "../../api/api"
import { REACT_APP_CUSTOMER, REACT_APP_TIMESHEET } from "../../utils/common"


export async function getCompanyTimesheetList(pageNumber?: number, pageSize?: number, search?: string, body?: any){
    const Details = postAPI(REACT_APP_TIMESHEET  + `/company-timesheets?search=${search}&page=${pageNumber}&size=${pageSize}`, body)
    return Details
}

export async function getCompany() {
    const Details = getAPI( REACT_APP_CUSTOMER + "/customer-list")
    return Details
}